import { CustomCarousel } from '../components/CustomCarousel/index';

const TilesBannerWidget = ({ widgetInformation }) => {
  return <CustomCarousel configData={widgetInformation} />;
};

export default TilesBannerWidget;
